/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   email validator
 */

import * as Yup from 'yup'

export const emailValidator = Yup.string()
  .required('Please enter a valid email')
  .email('Please enter a valid email')
